"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryServiceNS = void 0;
var SentryServiceNS;
(function (SentryServiceNS) {
    SentryServiceNS.SENTRY_SERVICE_ID = Symbol.for("SentryService");
})(SentryServiceNS = exports.SentryServiceNS || (exports.SentryServiceNS = {}));
//# sourceMappingURL=sentry.types.js.map